import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import type { ReactNode } from 'react'
import styled from 'styled-components'

const HeaderTitleWrapper = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
`

const Title = styled(Heading)`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Subtitle = styled(BodyText)`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

interface Props {
  title: ReactNode
  subtitle?: ReactNode
}

function TripDrawerHeaderTitle({ title, subtitle }: Props) {
  return (
    <HeaderTitleWrapper>
      <Title variant="heading4">{title}</Title>
      {subtitle && (
        <Subtitle variant="small" colour="light-foreground-alt">
          {subtitle}
        </Subtitle>
      )}
    </HeaderTitleWrapper>
  )
}

export default TripDrawerHeaderTitle
